import React, { useEffect, useState, useRef } from "react";
import {
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Label,
  Input,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Container,
  Button,
} from "reactstrap";
import { showLoading } from "react-global-loading";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import InspectionCycleStatus from "./InspectionCycleStatus";
import ClientType from "./ClientType";
import WorkType from "./WorkType";
import IndustryType from "./IndustryType";
import "../Standards/Standards.scss";
import FeatherIcon from "feather-icons-react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Toolbar } from "../../components/Common/LegacyGridAdapter";

//Import Icons

// //Import Scrollbar

const SystemIndex = () => {
  const [activeTab, setactiveTab] = useState(1);
  const [active, setActive] = useState("1");
  const [newWorkTypeRequest, setNewWorkTypeRequest] = useState(0);
  const [newClientTypeRequest, setNewClientTypeRequest] = useState(0);
  const [newIndustryTypeRequest, setNewIndustryTypeRequest] = useState(0);
  const ref = useRef();

  useEffect(() => {
    //var menu = new MetisMenu("#sub-menu");
  }, []);

  const showOverview = (even) => {
    setactiveTab(1);
  };

  const showActivity = (even) => {
    setactiveTab(2);
  };

  const showConversation = (even) => {
    setactiveTab(3);
  };

  const showContacts = (even) => {
    setactiveTab(4);
  };

  const showDeals = (even) => {
    setactiveTab(5);
  };

  const showFiles = (even) => {
    setactiveTab(6);
  };

  return (
    <React.Fragment>
      <div className="page-content standards-page piers-page">
        <Container fluid>
          <header className="standards-page__header piers-page-header">
            <div>
              <h1 className="piers-page-title">References</h1>
              <p>
                Manage the shared reference values used across inspections and
                engagements.
              </p>
            </div>
            {activeTab !== 1 && (
              <button
                type="button"
                className="standards-page__create"
                onClick={() => {
                  if (activeTab === 3)
                    setNewWorkTypeRequest((request) => request + 1);
                  if (activeTab === 4)
                    setNewClientTypeRequest((request) => request + 1);
                  if (activeTab === 5)
                    setNewIndustryTypeRequest((request) => request + 1);
                }}
              >
                <i className="bx bx-plus" /> New{" "}
                {activeTab === 3
                  ? "Work Type"
                  : activeTab === 4
                  ? "Client Type"
                  : "Industry Type"}
              </button>
            )}
          </header>
          <CardBody className="standards-page__body">
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
              <Nav tabs className="standards-page__tabs">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {
                      setactiveTab(1);
                    }}
                  >
                    <span>Inspection Cycle Status</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 3 })}
                    onClick={() => {
                      setactiveTab(3);
                    }}
                  >
                    <span>Work Type</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 4 })}
                    onClick={() => {
                      setactiveTab(4);
                    }}
                  >
                    <span>Client Type</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 5 })}
                    onClick={() => {
                      setactiveTab(5);
                    }}
                  >
                    <span>Industry Type</span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                className="twitter-bs-wizard-tab-content1 standards-page__tabs-content"
                activeTab={activeTab}
              >
                <TabPane tabId={1}>
                  <InspectionCycleStatus />
                </TabPane>
                <TabPane tabId={3}>
                  <WorkType createRequest={newWorkTypeRequest} />
                </TabPane>
                <TabPane tabId={4}>
                  <ClientType createRequest={newClientTypeRequest} />
                </TabPane>
                <TabPane tabId={5}>
                  <IndustryType createRequest={newIndustryTypeRequest} />
                </TabPane>
              </TabContent>
            </div>
          </CardBody>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SystemIndex;
